<div class="modal-header">
  <h4 class="modal-title no-transform">Select Gift Card Image</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="photo-form">
  <div class="modal-body">
    <div class="row py-1">
      <div class="col">
        <div class="custom-file">
          <input type="file" class="custom-file-input" (change)="onFileChange($event)" accept="image/png, image/jpeg" />
          <label class="custom-file-label" for="addImage">
            {{ photoFormControl.value?.name }}
          </label>
        </div>
      </div>
    </div>
    <div class="row py-3">
      <div class="col text-center">
        <button
          type="submit"
          class="btn em-btn em-btn-green"
          [disabled]="photoFormControl.invalid"
          (click)="onSubmit()"
        >
          Select
        </button>
      </div>
    </div>
  </div>
</div>
